export default "__VITE_ASSET__DjhLf1v0__"